<template>
  <div class="pa-4 animate__animated animate__fadeIn" id="test">
    <h2 class="title_tab mb-3">
      เกี่ยวกับเรา
      <v-btn class="float-right" color="#515148" @click="mode=!mode" small outlined v-if="!mode">
        {{mode?'ยกเลิก':'แก้ไข'}}
        <v-icon x-small v-if="!mode" class="ml-1">fas fa-pencil-alt</v-icon>
      </v-btn>
      <v-btn v-if="mode" class="float-right" color="#cb1a1a" @click="canCel()" small outlined>ยกเลิก</v-btn>
    </h2>

    <!-- <pre>{{about_file_image_from_api}}</pre> -->
    <v-form ref="form" @submit.prevent="save">
      <v-row style="font-size:16px;" :class="$vuetify.breakpoint.xsOnly?'pt-0':'pt-2'">
        <v-col cols="12" :class="$vuetify.breakpoint.xsOnly?'py-0':'py-4'">
          <v-row align="center" justify="center">
            <v-col
              :cols="$vuetify.breakpoint.xsOnly?'12':'12'"
              xs="12"
              sm="4"
              md="4"
              lg="3"
              xl="3"
              align="center"
            >
              <!-- style="min-height:180px;background-image:url('https://stickershop.line-scdn.net/stickershop/v1/product/1284254/LINEStorePC/main.png;compress=true'); background-position:center center; background-size:cover;" -->
              <!-- <div></div> -->
              <v-card tile v-if="image_path_by_id==''&&about_file_image_upload==''">
                <v-progress-circular
                  v-if="image_crop_delete!='delete'"
                  class="my-12"
                  :width="3"
                  color="red"
                  indeterminate
                ></v-progress-circular>
                <v-icon class="my-12" v-if="image_crop_delete=='delete'">mdi-image-area</v-icon>
              </v-card>
              <v-img
                :loading="true"
                aspect-ratio="1.6"
                v-if="image_path_by_id!=''"
                :src="image_path_by_id"
              ></v-img>
              <v-img
                v-show="about_file_image_upload!=''&&about_file_image_upload_show!=''"
                :src="about_file_image_upload_show"
                aspect-ratio="1.6"
              />
            </v-col>
            <v-col
              :cols="$vuetify.breakpoint.xsOnly?'12':'12'"
              sm="8"
              md="8"
              xl="9"
              lg="9"
              :class="$vuetify.breakpoint.xsOnly?'py-2':''"
            >
              <div
                :style="mode?'background-color:#ededed;':''"
                :class="$vuetify.breakpoint.xsOnly?'pa-1':'py-2'"
              >
                <v-card-title :class="$vuetify.breakpoint.xsOnly?'image-title pa-1':'image-title'">
                  ภาพประกอบ
                  <span class="pl-1" style="color:red;">*</span>
                </v-card-title>
                <v-card-text>
                  <v-row class="pl-3">
                    <v-col
                      class="py-0"
                      :cols="x_mobile?8:9"
                      sm="8"
                      md="10"
                      xl="10"
                      lg="10"
                      style="background:white;"
                    >
                      <v-list-item-title
                        v-if="about_file_image_from_api!=''"
                        class="font-kanit-light"
                      >{{about_file_image_from_api!=''?about_file_image_from_api.filename:''}}</v-list-item-title>
                      <v-list-item-title
                        v-if="about_file_image_upload!=''"
                        class="font-kanit-light"
                      >{{about_file_image_upload_show_name!=''?about_file_image_upload_show_name:''}}</v-list-item-title>
                    </v-col>

                    <v-col class="py-0" :cols="x_mobile?4:3" sm="4" md="2" xl="2" lg="2">
                      <v-btn
                        color="#6a6262"
                        dark
                        x-small
                        @click="ImageCropieOpen()"
                        v-show="mode"
                        block
                      >
                        <span
                          dark
                          style="font-size:12px;"
                          class="white--text font-kanit-light"
                        >เลือกรูป</span>
                      </v-btn>
                      <!-- <v-card color="#6a6262" class="text-center" v-show="mode">
                        <label for="about_image_file">
                          <span
                            dark
                            style="font-size:12px;"
                            class="white--text font-kanit-light"
                          >เลือกรูป</span>
                        </label>
                        <file-upload
                          input-id="about_image_file"
                          :directory="directory"
                          :accept="acceptphoto"
                          :extensions="extensionsphoto"
                          :size="size || 0"
                          :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
                          :headers="headers"
                          :data="data"
                          @input-filter="inputFilter"
                          v-model="about_file_image_upload"
                          @input-file="inputFile"
                          ref="about_media"
                        ></file-upload>
                      </v-card>-->
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <!-- </v-col> -->

        <v-col cols="12" sm="12" md="12" xl="12" class="pt-0 pb-0">
          <div>
            <div v-show="mode">
              <quill-editor
                ref="myTextEditor"
                class="ql-container ql-formats"
                v-model="content"
                :options="editorOption"
              ></quill-editor>
            </div>
            <!-- <v-footer :height="$vuetify.breakpoint.xsOnly?'20px':'45px'" class="ql-toolbar ql-snow"></v-footer> -->
            <div v-show="!mode" v-html="content" class="style-text-editor"></div>
          </div>
        </v-col>
        <v-col>
          <v-spacer></v-spacer>
          <v-btn
            color="button"
            class="float-right"
            v-show="mode"
            dark
            :loading="btn_loading"
            type="submit"
            small
          >บันทึก</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <CropImg
      ref="crop_image"
      @profileImg="setEmitProfileImg"
      @profileImgShow="setEmitProfileImgShow"
      @image_crop_name="setImageCropName"
    ></CropImg>
  </div>
</template>
<script>
import hljs from "highlight.js";
import FileUpload from "vue-upload-component";
import CropImg from "../components/CropImg";
export default {
  components: {
    FileUpload,
    CropImg,
  },
  data() {
    return {
      env: process.env.VUE_APP_API,
      header_token: { headers: { token: this.$session.get("token") } },
      mode: false,
      profile: {},
      btn_loading: false,
      select_agenda: [],
      isUpdating: false,
      about_file_image_from_api: {},
      about_file_image_upload: "",
      about_file_image_upload_show: "",
      about_file_image_upload_show_name: "",
      image_crop_delete: "",
      image_path_by_id: "",
      content: ``,
      all_about_data: {},
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            // [{ header: 1 }, { header: 2 }],

            // [{ size: ["small", false, "large", "huge"] }],
            // [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ font: [] }],
            // [{ color: [] }, { background: [] }],

            // [{ align: [] }],
            [{ list: "bullet" }],
            // ["clean"],
            // ['link', 'image', 'video']
            // ["link"],
          ],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value,
          },
        },
      },
      // image
      minSize: "",
      size: "",
      acceptphoto: "image/png,image/gif,image/jpeg,image/jpg", //,video/mp4,video/x-m4v,video/*
      extensionsphoto: "gif,jpg,jpeg,png",
      directory: false,
      thread: 3,
      postAction: "/upload/post",
      headers: {
        "X-Csrf-Token": "xxxx",
      },
      data: {
        _csrf_token: "xxxxxx",
      },
      status_mode_crop: "",
      autoCompress: "",
      uploadAuto: true,
    };
  },

  mounted() {},
  created() {
    // document.body.scrollTop = 0;
    // document.documentElement.scrollTop = 0;
    this.getData();
  },
  computed: {
    editor() {
      return this.$refs.myTextEditor.quill;
    },
    contentCode() {
      return hljs.highlightAuto(this.content).value;
    },
    x_mobile() {
      if (this.$vuetify.breakpoint.width < 400) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ImageCropieOpen() {
      this.$refs.crop_image.open(this.status_mode_crop);
    },
    // image
    // inputFile(newFile) {
    //   this.about_file_image_from_api = {};
    //   this.image_path_by_id = "";
    // },
    // inputFilter(newFile, oldFile, prevent) {
    //   if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
    //     newFile.blob = "";
    //     let URL = window.URL || window.webkitURL;
    //     if (URL && URL.createObjectURL) {
    //       newFile.blob = URL.createObjectURL(newFile.file);
    //     }
    //     newFile.thumb = "";
    //     if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
    //       newFile.thumb = newFile.blob;
    //     }
    //   }
    // },
    // lenght_data(data) {
    //   const max_lenght = 25;
    //   let data_string = "";
    //   for (let index = 0; index < max_lenght; index++) {
    //     data_string += data[index];
    //   }
    //   data_string += "...";
    //   if (data.length < max_lenght) {
    //     return data;
    //   } else {
    //     return data_string;
    //   }
    // },

    getData() {
      this.status_mode_crop = "add";
      let about = {};
      this.all_about_data = {};

      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/about", this.header_token)
        .then((response) => {
          // console.log(response.data.result);
          about = response.data.result;
          if (response.data.result && response.data.status == "OK") {
            this.axios({
              url:
                process.env.VUE_APP_API +
                "/api/v1/image/" +
                about.image.image_id,
              method: "GET",
              responseType: "blob", // important
              headers: { token: this.$session.get("token") },
            })
              .then((response) => {
                var url = window.URL.createObjectURL(new Blob([response.data]));
                this.image_path_by_id = url;
              })
              .catch((err) => {
                this.image_path_by_id = "ไม่สามารถโหลดรูปได้";
              });
            this.image_crop_delete = "";
            this.about_file_image_from_api = about.image;
            this.content = about.description == null ? "" : about.description;
          }
        });
    },
    canCel() {
      // this.$refs.about_media.remove(this.about_file_image_upload[0]);
      this.about_file_image_upload = "";
      this.about_file_image_upload_show = "";
      this.about_file_image_upload_show_name = "";
      this.image_crop_delete = "";
      this.mode = false;
      this.btn_loading = false;
      this.getData();
    },
    save() {
      // console.log(this.about_file_image_upload[0].file.name);
      // let name = "";
      // console.log(name.type);
      // name = this.about_file_image_upload[0].file.name;
      // this.about_file_image_upload[0].file.name = this.lenght_data(name);
      // console.log(this.about_file_image_upload[0].file.name);
      this.btn_loading = true;
      this.profile = this.$session.get("profile");
      let data = {};
      let form = new FormData();
      if (
        this.about_file_image_from_api != {} &&
        (this.about_file_image_upload == "" ||
          this.about_file_image_upload.length == 0)
      ) {
        data = {
          image_id: this.about_file_image_from_api.image_id,
          description: this.content == "" ? null : this.content,
          update_by: this.profile.staff_id,
        };
        // console.log(data);
        this.axios
          .put(
            process.env.VUE_APP_API + "/api/v1/about",
            data,
            this.header_token
          )
          .then((response) => {
            if (
              response.data.status == "OK" &&
              response.data.status != "FAIL"
            ) {
              this.$swal.fire({
                icon: "success",
                width: 500,
                title: response.data.message,
                text: "ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });

              this.canCel();
            } else {
              this.$swal.fire({
                icon: "error",
                width: 500,
                title: response.data.message,
                text: " กรุณาตรวจสอบข้อมูลของท่านอีกครั้ง",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
            }
          })
          .catch((err) => {
            this.$swal.fire({
              icon: "error",
              width: 500,
              title: "เกิดข้อผิดพลาด",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
          });
      } else if (
        this.about_file_image_upload != "" ||
        this.about_file_image_upload.length != 0
      ) {
        if (this.about_file_image_upload_show_name.length < 50) {
          form = new FormData();
          form.append(
            "file",
            this.about_file_image_upload,
            this.about_file_image_upload_show_name
          );
          this.axios
            .post(
              process.env.VUE_APP_API + "/api/v1/image/",
              form,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data);
              if (
                response.data.result.image_id &&
                response.data.status == "OK" &&
                response.data.status != "FAIL"
              ) {
                let image_id = response.data.result.image_id;
                data = {
                  image_id: image_id,
                  description: this.content == "" ? null : this.content,
                  update_by: this.profile.staff_id,
                };
                // console.log(data);
                this.axios
                  .put(
                    process.env.VUE_APP_API + "/api/v1/about",
                    data,
                    this.header_token
                  )
                  .then((response) => {
                    if (
                      response.data.status == "OK" &&
                      response.data.status != "FAIL"
                    ) {
                      this.$swal.fire({
                        icon: "success",
                        width: 500,
                        title: response.data.message,
                        text: "ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        showCloseButton: true,
                      });
                      this.canCel();
                    } else {
                      this.$swal.fire({
                        icon: "error",
                        width: 500,
                        title: response.data.message,
                        text: " กรุณาตรวจสอบข้อมูลของท่านอีกครั้ง",
                        showConfirmButton: false,
                        timer: 2000,
                        showCloseButton: true,
                      });
                    }
                  });
              }
            })
            .catch((err) => {
              this.$swal.fire({
                icon: "error",
                width: 500,
                title: "เกิดข้อผิดพลาด",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
            });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ชื่อไฟล์ยาวเกินไป",
            text: "กรุณาเปลี่ยนชื่อไฟล์ให้มีความยาวน้อยกว่า 45 ตัว",
            showConfirmButton: false,
            timer: 2000,
            showCloseButton: true,
          });
        }
        // // this.about_file_image_upload[0].file.name = this.lenght_data(this.about_file_image_upload[0].file.name)
        // console.log(this.about_file_image_upload[0].file.name.length);
        // let name = "";
        // console.log(name.type);
        // name = this.about_file_image_upload[0].file.name;
        // this.about_file_image_upload[0].file.name = this.lenght_data(name);
        // console.log(this.about_file_image_upload[0].file.name);
      } else {
        this.$swal.fire({
          icon: "error",
          text: "กรุณาตรวจสอบข้อมูล",
          showConfirmButton: false,
          timer: 2000,
          showCloseButton: true,
        });
      }
    },
    setEmitProfileImg(value) {
      this.about_file_image_from_api = {};
      this.image_path_by_id = "";
      // console.log(value);
      this.about_file_image_upload = value;
      // this.dataProfileImg.append("file", value);
      // this.checkEmitProfileImg();
    },
    setEmitProfileImgShow(value) {
      this.status_mode_crop = "";
      if (value == "delete") {
        this.image_crop_delete = "delete";
        this.about_file_image_upload_show = "";
      } else {
        // console.log(value);
        this.about_file_image_upload_show = value;
      }

      // this.image = value;
      // this.checkEmitProfileImg();
    },
    setImageCropName(value) {
      // console.log(value);
      this.about_file_image_upload_show_name = value;
    },
  },
};
</script>

<style lang="scss">
.announcement_btn_bar {
  background-image: linear-gradient(#ffffff, #cccccc);
  font-size: 9px;
}
.ql-toolbar {
  // background-image: linear-gradient(#e5e5e5, white);
  background-color: #726e6e;
}
.ql-toolbar.ql-snow .ql-formats {
  margin-right: 10px;
  color: #ffffff;
  // border: 1px solid #bec0c2;
}
.ql-snow .ql-stroke {
  stroke: #fafafa !important;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}
.ql-snow .ql-fill {
  fill: #fafafa !important;
}
.ql-snow .ql-picker {
  color: #fafafa !important;
}
.ql-snow .ql-picker-options .ql-picker-item {
  color: #1a1818;
}
.quill-code {
  border: none;
  height: auto;
  > code {
    width: 100%;
    margin-top: 50px;
    padding: 1rem;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0;
    height: 10rem;
    overflow-y: auto;
    resize: vertical;
  }
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
  height: 250px;
}
.ql-expanded .ql-picker-options {
  background: darkgray;
}
.ql-toolbar.ql-snow .ql-picker-options {
  background: darkgray;
}
</style>
